import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e85a13d8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "components__rec-diagnosis-selector" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Wählen Sie die Diagnose, für die die Beobachtung durchgeführt wurde. Es können auch mehrere Optionen gewählt werden. ", -1))
const _hoisted_3 = ["onUpdate:modelValue", "disabled"]
const _hoisted_4 = ["name", "value"]

import { recProps } from '../../mixins/rec-component';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'rec-diagnosis-selector',
  props: {...recProps()},
  setup(__props) {

  

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("ul", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.description.diagnoses, (diagnosis) => {
        return (_openBlock(), _createElementBlock("li", {
          key: diagnosis.id
        }, [
          _createElementVNode("label", null, [
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              "onUpdate:modelValue": ($event: any) => ((diagnosis.checked) = $event),
              disabled: _ctx.description.disabled
            }, null, 8, _hoisted_3), [
              [_vModelCheckbox, diagnosis.checked]
            ]),
            _createTextVNode(" " + _toDisplayString(diagnosis.label), 1)
          ]),
          (diagnosis.checked)
            ? (_openBlock(), _createElementBlock("input", {
                key: 0,
                type: "hidden",
                name: _ctx.description.name,
                value: diagnosis.id
              }, null, 8, _hoisted_4))
            : _createCommentVNode("", true)
        ]))
      }), 128))
    ])
  ]))
}
}

})